import React from 'react';

import { Link } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';

import { hasPrivilege } from '../../../utils/cookies';
import { getPrivilegeString } from '../../../utils/privileges';
import './memberDetailsAdminView.css';

const currentDate = new Date();

function membershipUntilFormatter(membershipUntil, currentDate, t) {
    if (membershipUntil) {
        if (new Date(membershipUntil) <= currentDate) {
            return (
                <div>
                    {Moment(membershipUntil).format('D.M.YYYY')}{' '}
                    <FontAwesomeIcon icon="exclamation-triangle" color="red" />
                </div>
            );
        } else {
            return <div>{Moment(membershipUntil).format('D.M.YYYY')}</div>;
        }
    } else {
        return <div>{t('memberDetails.feeUnpaid')}</div>;
    }
}

const MemberDetailsAdminView = ({
    firstName,
    lastName,
    utuAccount,
    email,
    homeTown,
    tyyMember,
    privileges,
    entitledToCap,
    entitledToPatch,
    membershipSince,
    membershipUntil,
    createdAt,
    accepted,
    message,
    success,
    handleRemove,
    memberID,
}) => {
    const { t } = useTranslation();

    return (
        <div className="container">
            {message ? (
                <Alert variant={!success ? 'danger' : 'success'}>
                    {t(message.key, message.params)}
                </Alert>
            ) : null}
            <Table striped hover>
                <tbody>
                    <tr>
                        <th>{t('memberDetails.firstName')}</th>
                        <td style={{ textTransform: 'capitalize' }}>
                            {firstName}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.lastName')}</th>
                        <td>{lastName}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.utuAccount')}</th>
                        <td>{utuAccount}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.email')}</th>
                        <td>{email}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.homeTown')}</th>
                        <td>{homeTown}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.tyyMember')}</th>
                        <td>
                            {tyyMember ? (
                                <p>
                                    {t('memberDetails.yes')}{' '}
                                    <FontAwesomeIcon icon="check" color="green" />
                                </p>
                            ) : (
                                <p>
                                    {t('memberDetails.no')}{' '}
                                    <FontAwesomeIcon icon="times" color="red" />
                                </p>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('adminMemberDetails.entitledToCap')}</th>
                        <td>
                            {entitledToCap ? (
                                <p>
                                    {t('memberDetails.yes')}{' '}
                                    <FontAwesomeIcon icon="check" color="green" />
                                </p>
                            ) : (
                                <p>
                                    {t('memberDetails.no')}{' '}
                                    <FontAwesomeIcon icon="times" color="red" />
                                </p>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('adminMemberDetails.entitledToPatch')}</th>
                        <td>
                            {entitledToPatch ? (
                                <p>
                                    {t('memberDetails.yes')}{' '}
                                    <FontAwesomeIcon icon="check" color="green" />
                                </p>
                            ) : (
                                <p>
                                    {t('memberDetails.no')}{' '}
                                    <FontAwesomeIcon icon="times" color="red" />
                                </p>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.membershipAccepted')}</th>
                        <td>
                            {accepted ? (
                                <p>
                                    {t('memberDetails.yes')}{' '}
                                    <FontAwesomeIcon icon="check" color="green" />
                                </p>
                            ) : (
                                <p>
                                    {t('memberDetails.no')}{' '}
                                    <FontAwesomeIcon icon="times" color="red" />
                                </p>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.roles')}</th>
                        <td>{getPrivilegeString(privileges)}</td>
                    </tr>

                    <tr>
                        <th>{t('memberDetails.membershipSince')}</th>
                        <td>
                            {membershipSince
                                ? Moment(membershipSince).format('D.M.YYYY')
                                : t('memberDetails.feeUnpaid')}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.membershipUntil')}</th>
                        <td>
                            {membershipUntilFormatter(
                                membershipUntil,
                                currentDate,
                                t
                            )}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('adminMemberDetails.createdAt')}</th>
                        <td>{Moment(createdAt).format('D.M.YYYY')}</td>
                    </tr>
                </tbody>
            </Table>
            <div className="buttons-row">
                <Link
                    className="btn btn-secondary secondary backbutton"
                    to="/admin"
                >
                    {t('common.back')}
                </Link>
                {hasPrivilege('boardmember') ||
                hasPrivilege('chairman') ||
                hasPrivilege('vicechairman') ||
                hasPrivilege('admin') ? (
                    <div className="destructive-buttons">
                        <Button
                            variant="danger"
                            className="btn btn-danger danger"
                            onClick={handleRemove}
                            style={{ textTransform: 'capitalize' }}
                        >
                            {t('adminMemberDetails.remove', {
                                name: `${firstName} ${lastName}`,
                            })}
                        </Button>
                        <Link
                            className="btn btn-success success"
                            to={`/profile/update/${memberID}`}
                        >
                            {t('memberDetails.update')}
                        </Link>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default MemberDetailsAdminView;
